var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-arrow"},[_c('span',{staticClass:"when-opened"},[_c('i',{staticClass:"dd-arrow i-Arrow-Up"})]),_c('span',{staticClass:"when-closed"},[_c('i',{staticClass:"dd-arrow i-Arrow-Down"})])])
}]

export { render, staticRenderFns }